<template>
  <div class="flex flex-col items-start">
    <span class="flex text-sm text-muted mb-3">{{ title }}</span>

    <div
      v-if="value"
      :class="[
        'bg-hint border border-solid border-light rounded overflow-hidden flex items-center justify-center mb-3',
        mode === 'icon' ? 'w-24 h-24' : 'w-64 h-36',
      ]"
    >
      <Attachment
        :id="value"
        :class="mode === 'icon' ? 'max-w-full max-h-full object-contain p-2' : 'w-full h-full object-cover'"
      />
    </div>

    <div class="flex flex-row items-center space-x-4">
      <VueUpload
        ref="upload"
        v-model="files"
        :input-id="$uniqid()"
        :multiple="false"
        accept="image/*"
        @input-file="onInputFile"
      >
        <button
          type="button"
          class="btn btn-xs btn-outline-primary"
          :disabled="uploading"
        >
          {{ uploading ? 'Загрузка…' : (value ? 'Заменить' : 'Загрузить') }}
        </button>
      </VueUpload>

      <ButtonBorderless
        v-if="value"
        theme="red"
        @click.native="clear"
      >
        Убрать
      </ButtonBorderless>
    </div>

    <span v-if="hint" class="text-12px text-gray-600 mt-3 max-w-150">
      {{ hint }}
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VueUpload from 'vue-upload-component';
import Attachment from '@/components/global/Attachment.vue';
import ButtonBorderless from '@/components/ButtonBorderless.vue';

export default {
  components: {
    VueUpload,
    Attachment,
    ButtonBorderless,
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'card',
      validator: (value) => ['icon', 'card'].includes(value),
    },
  },
  data() {
    return {
      files: [],
      uploading: false,
    };
  },
  methods: {
    ...mapActions({
      uploadAttachment: 'attachments/ACT_UPLOAD_ATTACHMENT',
    }),
    async onInputFile(file) {
      const source = file && file.file;
      if (!source || this.uploading) return;

      if (source.type && !source.type.startsWith('image/')) {
        this.$iwalyNotify.error({
          text: 'Можно загрузить только изображение.',
        });
        this.files = [];
        return;
      }

      this.uploading = true;
      try {
        const fd = new FormData();
        fd.append('file', source);
        const ids = await this.uploadAttachment(fd);
        const attachId = Array.isArray(ids) ? ids[0] : null;

        if (!attachId) {
          throw new Error('attachment_id_missing');
        }

        this.$emit('input', attachId);
      } catch (error) {
        console.log(error);
        this.$iwalyNotify.error({
          text: 'Не удалось загрузить изображение.',
        });
      } finally {
        this.uploading = false;
        this.files = [];
      }
    },
    clear() {
      this.$emit('input', null);
    },
  },
};
</script>
